import * as React from "react";
import type { SVGProps } from "react";
const SvgPaperWithUser = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={38}
    fill="none"
    viewBox="0 0 59 38" {...props}
  >
    <path
      fill="url(#paper-with-user_svg__a)"
      d="M34.542 36.9 2.22 23.857c-1.384-.495-1.676-2.324-.533-3.238L21.626 4.45a1.85 1.85 0 0 1 1.803-.292L56.78 17.571c1.384.495 1.676 2.324.533 3.238L38.225 36.303a3.82 3.82 0 0 1-3.683.597"
      opacity={0.7}
    />
    <path
      fill="#fff"
      stroke="#00217B"
      strokeDasharray="0.83 0.83"
      strokeMiterlimit={10}
      strokeWidth={0.229}
      d="M34.542 33.857 2.22 20.814C.836 20.32.544 18.49 1.687 17.576L21.626 1.408a1.85 1.85 0 0 1 1.803-.292L56.78 14.528c1.384.495 1.676 2.324.533 3.238L38.225 33.26a3.82 3.82 0 0 1-3.683.597Z"
    />
    <path
      fill="#BFDEFF"
      d="M13.422 7.846c-.724.648-1.385 1.512-1.448 2.515-.089 1.422 1.232 2.388 2.362 2.934 1.042.508 2.185.787 3.302 1.028 1.816.381 3.645.686 5.474.966s4.064.597 6.083.952c2.02.356 3.849.762 5.69 1.397 1.588.546 3.2 1.258 4.496 2.337 1.295 1.08 1.054.99 1.41 1.626a3.85 3.85 0 0 1 .482 1.74 3.17 3.17 0 0 1-.431 1.689c-.305.52-.826 1.028-1.41 1.359a4.54 4.54 0 0 1-1.956.571c-.686.038-.724.013-1.029-.025a2.9 2.9 0 0 1-.902-.267c-.24-.127-.127-.063-.19-.101s-.063-.039-.089-.064c-.038-.025-.025-.025-.038-.025a2 2 0 0 1-.152-.14c-.051-.05-.051-.05-.064-.076-.013-.013-.025-.038-.038-.051l.05.165v-.038c0-.038-.012.063 0 .013.014-.051 0-.051.014-.077.012-.025.038-.101 0-.012 0-.026.025-.051.038-.076s.025-.051.05-.064c-.038.05-.025.025 0 0l.064-.064c.05-.05-.026.013.013-.012.038-.026.088-.064.14-.09.05-.024.063-.024.088-.037a2.135 2.135 0 0 1 .445-.127c.14-.026.076-.013.114-.026s.038 0 .05 0c-.063 0-.012 0 0 0 .064 0 .166-.012.242-.025.165 0 .33-.013.495 0 .33 0 .699.038.991.089s.648.114.953.216.52.178.8.355c.61.369 1.143.915 1.511 1.55.394.686.546 1.46.14 2.133-.407.674.368.724.584.343 1.041-1.752-.52-3.873-2.057-4.711-.724-.394-1.588-.547-2.4-.61-.763-.064-1.64-.076-2.325.292s-.533.407-.622.737c-.09.33-.038.177-.038.266 0 .153.127.28.215.394.09.114.293.267.458.368.787.483 1.816.56 2.705.458s1.93-.47 2.718-1.118c.686-.559 1.194-1.334 1.384-2.197a4.3 4.3 0 0 0-.216-2.527c-.317-.8-1.016-1.664-1.778-2.3-1.778-1.485-4.039-2.336-6.248-2.958-2.553-.712-5.182-1.13-7.811-1.524-2.527-.381-5.055-.75-7.557-1.245-.825-.165-1.638-.343-2.438-.597s-.33-.114-.483-.165c-.152-.05-.152-.05-.216-.089-.063-.038-.076-.025-.101-.038s.05.025 0 0-.038-.013-.064-.025a9 9 0 0 1-.927-.483c-.305-.178-.825-.584-1.08-.978-.253-.394-.164-.28-.215-.457-.051-.178-.038-.165-.051-.241v-.407c0 .038 0-.076.013-.089 0-.038.012-.089.025-.127.025-.076.038-.152.076-.228s.051-.115.026-.051c.012-.038.038-.076.05-.114.077-.14.153-.28.242-.42s.089-.127.127-.19c0-.013.025-.025.038-.038.025-.038.063-.076.089-.102a4.6 4.6 0 0 1 .546-.559c.33-.292-.152-.774-.483-.482z"
      opacity={0.5}
    />
    <path
      fill="#BFDEFF"
      d="m28.433 25.7-10.82-5.118c-1.499-.71-1.613-2.375-.216-3.175 1.168-.673 2.629-1.384 4.229-1.892a20 20 0 0 1 2.603-.66c.534-.09 1.067-.127 1.6-.09-.304-.977-.152-2.057.56-2.984 1.435-1.88 4.559-2.476 6.985-1.333 2.425 1.143 3.213 3.594 1.778 5.474-.724.952-1.88 1.574-3.15 1.803.089.152.152.305.203.47.114.368.229.838.318 1.397.177 1.257-.356 3.429-.864 5.08-.343 1.105-1.956 1.638-3.213 1.041z"
    />
    <defs>
      <linearGradient
        id="paper-with-user_svg__a"
        x1={0.975}
        x2={58.025}
        y1={20.581}
        y2={20.581}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#228FE6" />
        <stop offset={0.2} stopColor="#1AA0E0" />
        <stop offset={0.3} stopColor="#0DBBD6" />
        <stop offset={0.4} stopColor="#00DACB" />
        <stop offset={0.8} stopColor="#00DACB" stopOpacity={0.4} />
        <stop offset={1} stopColor="#00DACB" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgPaperWithUser;
